import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import ApiInventarioProductoLog from "../../../../js/api/global/InventarioProductoLog";
import { openNotification } from "../../../controls/Notifications";
import { InventoriesProductoLogContext } from "../../../../js/app/context/InventoriesProductoLog";
import InventoriesLogList from "./partial/InventoriesLogList";
const InventoriesLog = () => {
  const [loading, setLoading] = useState(false);
  const [logProductos, setLogProductos] = useState([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      ApiInventarioProductoLog.GetInventarioProductoLogList(),
    ]).then((res) => {
      setLoading(false);
      const logProductos = res[0];
      if (
        logProductos.success 
      ) {
        setLogProductos(logProductos.dataList);
      } else {
        openNotification(
          "e",
          "Carga de datos",
          "Ha ocurrido un error al cargar la data"
        );
      }
    });
  }, []);

  return (
    <div className="container-s">
      <Divider dashed />
      <div>
        <InventoriesProductoLogContext.Provider
          value={{ logProductos, setLogProductos, loading }}
        >
          <InventoriesLogList />
        </InventoriesProductoLogContext.Provider>
      </div>
    </div>
  );
};

export default InventoriesLog;
